module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Suits_S8.6f3097a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Suits_S8.jpg
// module id = mkwg
// module chunks = 0